/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const TRIP_PLANNER_START_SEARCH_RESULTS = 'TRIP_PLANNER_START_SEARCH_RESULTS';
export const TRIP_PLANNER_END_SEARCH_RESULTS = 'TRIP_PLANNER_END_SEARCH_RESULTS';
export const GET_TRIP_PLANNER_SEARCH_RESULTS = 'GET_TRIP_PLANNER_SEARCH_RESULTS';
export const GET_TRIP_PLANNER_SEARCH_GEO_RESULTS = 'GET_TRIP_PLANNER_SEARCH_GEO_RESULTS';
export const GET_TRIP_PLANNER_SEARCH_ERROR = 'GET_TRIP_PLANNER_SEARCH_ERROR';
export const GET_TRIP_PLANNER_AGGREGATIONS = 'GET_TRIP_PLANNER_AGGREGATIONS';
export const GET_TRIP_PLANNER_GROUP_AGGREGATIONS = 'GET_TRIP_PLANNER_GROUP_AGGREGATIONS';
export const UPDATE_TRIP_PLANNER_CRITERIA = 'UPDATE_TRIP_PLANNER_CRITERIA';

export const GET_TRIP_PLANNER_RESET_AGGREGATIONS = 'GET_TRIP_PLANNER_RESET_AGGREGATIONS';
export const GET_TRIP_PLANNER_RESET_RESULTS = 'GET_TRIP_PLANNER_RESET_RESULTS';
export const GET_TRIP_PLANNER_DETAILED_ROUTE = 'GET_TRIP_PLANNER_DETAILED_ROUTE';
export const GET_TRIP_INVENTORY_ITEM_DETAILS = 'GET_TRIP_INVENTORY_ITEM_DETAILS';
export const GET_TRIP_INVENTORY_ITEM_DETAILS_ERROR =
    'GET_TRIP_INVENTORY_ITEM_DETAILS_ERROR';

export const GET_DIRECTIONS = 'GET_DIRECTIONS';
export const GET_DIRECTIONS_ERROR = 'GET_DIRECTIONS_ERROR';

export const GET_ITINERARY = 'GET_ITINERARY';
export const GET_ITINERARY_ERROR = 'GET_ITINERARY_ERROR';

export const GET_TRIP_DESTINATION_SUGGESTIONS = 'GET_TRIP_DESTINATION_SUGGESTIONS';
export const GET_TRIP_DESTINATION_SUGGESTIONS_ERROR =
    'GET_TRIP_DESTINATION_SUGGESTIONS_ERROR';

export const TRIP_PLANNER_ADD_DESTINATION = 'TRIP_PLANNER_ADD_DESTINATION';
export const TRIP_PLANNER_UPDATE_DESTINATION = 'TRIP_PLANNER_UPDATE_DESTINATION';
export const TRIP_PLANNER_DELETE_DESTINATION = 'TRIP_PLANNER_DELETE_DESTINATION';
export const TRIP_PLANNER_MOVE_DESTINATION = 'TRIP_PLANNER_MOVE_DESTINATION';

export const TRIP_PLANNER_SET_START_DATE = 'TRIP_PLANNER_SET_START_DATE';
export const TRIP_PLANNER_SET_END_DATE = 'TRIP_PLANNER_SET_END_DATE';
export const TRIP_PLANNER_SET_NAME = 'TRIP_PLANNER_SET_NAME';
export const TRIP_PLANNER_SET_GUEST_COUNTS = 'TRIP_PLANNER_SET_GUEST_COUNTS';
export const TRIP_PLANNER_ADD_FILTER = 'TRIP_PLANNER_ADD_FILTER';
export const TRIP_PLANNER_REMOVE_FILTER = 'TRIP_PLANNER_REMOVE_FILTER';
export const TRIP_PLANNER_SET_FILTER = 'TRIP_PLANNER_SET_FILTER';
export const TRIP_PLANNER_SET_RADIUS = 'TRIP_PLANNER_SET_RADIUS';
export const TRIP_PLANNER_SET_VIEW = 'TRIP_PLANNER_SET_VIEW';
export const TRIP_PLANNER_SET_ENABLE_OVERVIEW_MODAL =
    'TRIP_PLANNER_SET_ENABLE_OVERVIEW_MODAL';
export const TRIP_PLANNER_SET_DATA_BOOK_MODAL = 'TRIP_PLANNER_SET_DATA_BOOK_MODAL';
export const TRIP_PLANNER_UPDATE_DESTINATION_SEARCH_CRITERIA =
    'TRIP_PLANNER_UPDATE_DESTINATION_SEARCH_CRITERIA';
export const TRIP_PLANNER_SET_ACTIVE_DATE = 'TRIP_PLANNER_SET_ACTIVE_DATE';
export const TRIP_PLANNER_SET_ACTIVE_DESTINATION_INDEX =
    'TRIP_PLANNER_SET_ACTIVE_DESTINATION_INDEX';
export const TRIP_PLANNER_SET_ACTIVE_ITEM_INDEX = 'TRIP_PLANNER_SET_ACTIVE_ITEM_INDEX';
export const TRIP_PLANNER_SET_FILTERS_VISIBLE = 'TRIP_PLANNER_SET_FILTERS_VISIBLE';
export const TRIP_PLANNER_RESET_FILTERS = 'TRIP_PLANNER_RESET_FILTERS';
export const TRIP_PLANNER_ADD_SEARCH_FILTER = 'TRIP_PLANNER_ADD_SEARCH_FILTER';
export const TRIP_PLANNER_SET_SEARCH_FILTER = 'TRIP_PLANNER_SET_SEARCH_FILTER';
export const TRIP_PLANNER_REMOVE_SEARCH_FILTER = 'TRIP_PLANNER_REMOVE_SEARCH_FILTER';
export const TRIP_PLANNER_SET_TRIP_ID = 'TRIP_PLANNER_SET_TRIP_ID';
export const TRIP_PLANNER_SET_TRIP_SAVED = 'TRIP_PLANNER_SET_TRIP_SAVED';
export const TRIP_PLANNER_ERROR = 'TRIP_PLANNER_ERROR';
export const TRIP_PLANNER_SET_TRIP = 'TRIP_PLANNER_SET_TRIP';
export const TRIP_PLANNER_LOAD_USER_TRIPS = 'TRIP_PLANNER_LOAD_USER_TRIPS';
export const TRIP_PLANNER_LOAD_TRIP_IDEAS = 'TRIP_PLANNER_LOAD_TRIP_IDEAS';
export const TRIP_PLANNER_LOAD_ITEMS_DETAILS = 'TRIP_PLANNER_LOAD_ITEMS_DETAILS';
export const TRIP_PLANNER_LOAD_USER_PREFERENCES = 'TRIP_PLANNER_LOAD_USER_PREFERENCES';
export const TRIP_PLANNER_SET_HIDE_INTRO = 'TRIP_PLANNER_SET_HIDE_INTRO';
export const TRIP_PLANNER_SET_HIDE_BOOKING_INTRO = 'TRIP_PLANNER_SET_HIDE_BOOKING_INTRO';
export const TRIP_PLANNER_UPDATE_CRITERIAS = 'TRIP_PLANNER_UPDATE_CRITERIAS';
export const TRIP_PLANNER_LOAD_CAMPING_RESERVATIONS =
    'TRIP_PLANNER_LOAD_CAMPING_RESERVATIONS';
export const TRIP_PLANNER_LOAD_TICKET_RESERVATIONS =
    'TRIP_PLANNER_LOAD_TICKET_RESERVATIONS';
export const TRIP_PLANNER_LOAD_PERMIT_ISSUANCES = 'TRIP_PLANNER_LOAD_PERMIT_ISSUANCES';
export const TRIP_PLANNER_SET_SHOW_TRIP_SHARE_MODAL =
    'TRIP_PLANNER_SET_SHOW_TRIP_SHARE_MODAL';
export const TRIP_PLANNER_SET_SHOW_EDIT_ROUTE_MODAL =
    'TRIP_PLANNER_SET_SHOW_EDIT_ROUTE_MODAL';
export const TRIP_PLANNER_SET_SHOW_TRIP_ITEM_ADD_MODAL =
    'TRIP_PLANNER_SET_SHOW_TRIP_ITEM_ADD_MODAL';
export const TRIP_PLANNER_SET_SEARCH_LOCATION = 'TRIP_PLANNER_SET_SEARCH_LOCATION';

export const TRIP_PLANNER_ADD_ITEM = 'TRIP_PLANNER_ADD_ITEM';
export const TRIP_PLANNER_DELETE_ITEM = 'TRIP_PLANNER_DELETE_ITEM';

export const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ';
export const FNS_DATE_FORMAT = "yyyy-MM-dd'T'HH:mm:ss'Z'";
export const FNS_LL_DATE_FORMAT = 'MMM d, yyyy';
export const FNS_BASIC_DATE_FORMAT = 'MM/dd/yyyy';

export const DESTINATION_RESULT_PAGE_SIZE = 4;
export const DEFAULT_RADIUS = 25;

export const BLANK_TRIP_TEMPLATE = {
    id: null,
    name: '',
    radius: 25,
    start_date: null,
    end_date: null,
    guest_counts: {},
    account_id: null,
    is_public: true,
    destinations: [
        {
            name: '',
            lat: null,
            lng: null,
            entity_id: null,
            entity_type: null,
            items: [],
        },
        {
            name: '',
            lat: null,
            lng: null,
            duration: 1,
            entity_id: null,
            entity_type: null,
            items: [],
        },
    ],
};
